import { DefaultPalette } from '@fluentui/style-utilities/lib';

export const SONORA_FEATURE_NAME: string = 'Sonora';

export const SERVER_CALL_TIMEOUT: number = 3500;

// Sonora Meeting Avalaibility
export const MAX_ATTENDEES_FOR_AVAILABILITY = 5;
export const INTERNAL_MAILBOX_TYPE = 'InternalMailbox';

// Sonora ghost text hints
export const SONORA_INLINE_HINT_CLASS = 'SonoraInlineHint';
export const SONORA_INTRO_HINT_ID = 'sonoraIntroHintParent';
export const SONORA_ZERO_QUERY_HINT_PARENT = 'sonoraZeroQueryHintParent';
export const WHITE_SPACE = 'pre-wrap';
export const SUGGESTION_TEXT_COLOR = DefaultPalette.neutralSecondary;
export const SUGGESTION_TEXT_COLOR_DARK = DefaultPalette.neutralTertiary;

// Sonora custom settings used for AL to Honeybee web service
export const INIT_3S_SEARCH = 'initSearch';
export const GET_MESSAGE_ITEM_BODY = 'GetMessageItemBody';
export const GET_RICH_STICKY_NOTE_TEXT = 'GetRichStickyNoteText';
export const TIME_ZONE = 'TimeZone';
export const ATTENDEES = 'Attendees';
export const USE_DEBUG_MODE = 'useDebugMode'; // TODO: Use value from AL package

// Telemetry

export const SONORA_PANEL_MOUSE_ENTERING = 'MouseEntering';
export const SONORA_PANEL_DOWN_ARROW = 'DownArrow';
export const SONORA_PANEL_UP_ARROW = 'UpArrow';

// Indicates while the deep links are created from meeting availability.
export const SONORA_MEETING_DEEP_LINK_CREATED = 'SonoraMeetingDeepLinkCreated';

// Teaching bubble
export const SONORA_TEACHING_BUBBLE_DISMISS_CHARS = [':', '@', '/'];
